import React from 'react'
import FontAwesome from 'react-fontawesome';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Modal, Form } from 'react-bootstrap';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connectModal } from 'redux-modal';
import * as validators from 'misc/validators';
import { multilingualSplitRequest } from 'actions/jobs/managers'
import { getMultilingualServiceOptions } from 'selectors/options';
import { JOB_MULTILINGUAL_SPLIT_ISSUE_MODAL, JOB_MULTILINGUAL_SPLIT_ISSUE_FORM } from 'misc/constants';
import { CoordinatorSelectOptionField } from 'components/core/SelectOptionField';
import Spinner from 'components/core/Spinner';
import SelectField from 'components/core/SelectField';
import CheckboxField from 'components/core/CheckboxField';
import PureRenderComponent from 'components/core/PureRenderComponent';


class JobMultilingualSplitIssueModal extends PureRenderComponent { 
  handleIssue = (values) => {
    this.props.multilingualSplitRequest(this.props.jobId, {
      services: values.services.split(','),
      coordinator: values.coordinator,
    });
  }

  render() {
    const {
      show,
      handleHide,
      serviceOptions,
      isLoading,
      handleSubmit,
    } = this.props;

    return (
      <Modal
        show={show}
        onHide={handleHide}
        animation={true}
        backdrop="static">
        <Form
          noValidate
          autoComplete="off">
          <Modal.Header closeButton>
            <Modal.Title>Multilingual split issue jobs</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Field
                name="services"
                label="Service"
                options={serviceOptions}
                multi={true}
                isRequired={true}
                closeOnSelect={false}
                onSelectResetsInput={false}
                onBlurResetsInput={false}
                validate={[
                  validators.required,
                ]}
                component={SelectField.Labeled} />
            <CoordinatorSelectOptionField
              isRequired={true}
              validate={[
                validators.required,
              ]} />
            <Field
                name="requireAutoLock"
                label="Lock repeated segments"
                className="mt-3 mb-3"
                component={CheckboxField.Labeled} />      
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="pull-left"
              bsSize="sm"
              type="button"
              onClick={handleHide}>
              <FontAwesome name="close" className="mr-5" />Close
            </Button>
            <Button
              bsStyle="primary"
              bsSize="sm"
              type="submit"
              disabled={!this.props.selectedServices}
              onClick={handleSubmit(values => this.handleIssue(values))}>
              <FontAwesome name="paper-plane-o" className="mr-5" />Submit
            </Button>
          </Modal.Footer>
          <Spinner isLoading={isLoading} />
        </Form>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const serviceOptions = (
    state.modal &&
    state.modal[JOB_MULTILINGUAL_SPLIT_ISSUE_MODAL] &&
    state.modal[JOB_MULTILINGUAL_SPLIT_ISSUE_MODAL].props &&
    state.modal[JOB_MULTILINGUAL_SPLIT_ISSUE_MODAL].props.jobId
  )
    ? getMultilingualServiceOptions(state, state.modal[JOB_MULTILINGUAL_SPLIT_ISSUE_MODAL].props.jobId)
    : []

  const formSelector = formValueSelector(JOB_MULTILINGUAL_SPLIT_ISSUE_FORM);
  const selectedServices = formSelector(state, 'services');
  const initialValues = { requireAutoLock: true }

  return {
    serviceOptions,
    selectedServices,
    initialValues,
    isLoading: false,
  }
}

const mapDispatchToProps = (disptach) => {
  return bindActionCreators({
    multilingualSplitRequest
  }, disptach)
}

JobMultilingualSplitIssueModal = connectModal({
  name: JOB_MULTILINGUAL_SPLIT_ISSUE_MODAL
})(JobMultilingualSplitIssueModal);

JobMultilingualSplitIssueModal = reduxForm({
  form: JOB_MULTILINGUAL_SPLIT_ISSUE_FORM
})(JobMultilingualSplitIssueModal);


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(JobMultilingualSplitIssueModal)

